module.exports = __webpack_public_path__ + "static/media/hold_white.9f662612.svg";